import { render, staticRenderFns } from "./comTMBSke.vue?vue&type=template&id=65411788&scoped=true"
import script from "./comTMBSke.vue?vue&type=script&lang=js"
export * from "./comTMBSke.vue?vue&type=script&lang=js"
import style0 from "./comTMBSke.vue?vue&type=style&index=0&id=65411788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65411788",
  null
  
)

export default component.exports